import fstyles from "../frank.module.css";
import styles from "../home.module.css";

export default function Home({toResults}) {
  return (
    <div className={styles.page}>
      <div className={fstyles.content}>
        <h1>Frank Lara Memorial Marathon</h1>
        <p> The Frank Lara Memorial Marathon actually began when its founder, Frank Lara, was still alive, which he is <br /> 
        today. <br />
        When asked to comment, he did not. <br /> </p>

        <p>The marathon remains the only one in the world that participants must complete an incredible complicated <br />
        board game in the middle of the run. <br />
        Activities in the race may include Playstation VR, obligatory nudity, and uncontrolled pooping. <br /> </p>

        <p>Frank founded the marathon in 2030, allowing only himself as the sole participant. <br />
        Unfortunately, he lost the race in the final moments to his dog, George. <br /> </p>

        <p>He now lives and trains in a custom-built balloon raft floating at 25,000 feet. When asked, <br />
        he stated he needs to “altitude train harder” and provided no further comment. </p>

        <button onClick = {toResults} className = {fstyles.button}>View Official Results →</button>
      </div>
    </div>
  );
}
